import React from 'react'
import { useHistory } from 'react-router'
import Guest from '../components/Guest'
import Header from '../components/Header'
import { useUser } from '../contexts/user'

export default function Home() {
  const history = useHistory()
  const { user } = useUser()
  if (!user.id) {
    history.push('/')
    return null
  }
  return (
    <div>
      <Header />
      <Guest />
    </div>
  )
}
